<template>
  <div class="let-page-title">Undervisning</div>
</template>

<style lang="scss"></style>
